// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".date-time-input {\n  width: 100%;\n}\n.date-time-input > .period-select {\n  width: calc(100% - 70px);\n  vertical-align: top;\n}\n.date-time-input > .period-select > .drop-panel {\n  width: 100%;\n}\n.date-time-input > .text-input {\n  display: inline-block;\n  min-width: 60px !important;\n  margin-left: 10px;\n  vertical-align: top;\n}\n", ""]);
// Exports
module.exports = exports;
